import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar } from 'swiper/modules';


document.addEventListener("DOMContentLoaded", function () {

    const swiper = new Swiper('.js__main_slider', {
        slidesPerView: 1,
        loop: false,
        centeredSlides: false,
        modules: [Navigation, Pagination],
        navigation: {
            nextEl: '.main__swiper__next',
            prevEl: '.main__swiper__prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });

    const servicesList = new Swiper('.swiper-reviews', {
        modules: [Navigation, Pagination, Scrollbar],
        loop: true,
        slidesPerView: 1.2,
        spaceBetween: 32,
        navigation: {
            nextEl: '.swiper__next',
            prevEl: '.swiper__prev',
        },
        scrollbar: {
            el: '.reviews__scrollbar',
            draggable: true,
        },
        breakpoints: {
            1120: {
                slidesPerView: 3,
            },
            768: {
                slidesPerView: 2,
            },
            // 768: {
            //     slidesPerView: 3,
            // }
        }
    });
});
